export const API_CONFIG = {
	userBase : 'https://cloud-backyard.colourlife.com',
    base : 'https://cloud.colourlife.com',
    yun_url : 'https://yun.colourlife.com',
    market_url: 'https://market-cloud.colourlife.com/market_ui/',
    yun_base:'https://admin-cloud.colourlife.com',
    cloud_token: 'cloud_token',
    company_token:'company_token',
    weixinBase: 'https://weworkbackend-cloud.colourlife.com'
};


// WEBPACK FOOTER //
// ./src/api/config.js